import { Avatar, AvatarBadge, AvatarGroup, Box, FormControl, FormErrorMessage, FormHelperText, Input, InputAddon, InputGroup, Select } from '@chakra-ui/react'
import React, { ChangeEvent, useEffect, useState } from 'react'

import { normalizeString } from 'utils/functions/formatString'
import { useSubscriberContext } from 'providers/SubscriberProvider'
import { useFormContext } from 'providers/FormProvider'
import { ICountries } from 'providers/ISubscriberProvider.d'

interface InputPhoneProps {
  handleFieldValidation: (e: any) => void;
  handleFieldChange: (e: any) => void;
  handleNumberFieldChange: (e: any) => void;
  handleResetValidation: (e: any) => void;
  maxLengthcodArea: number;
  maxLengthNumber: number;
  values: {
    countryPhoneCode: string,
    codArea: string,
    phone: string,
    selectedCountry: string,
  },
  error,
  errorMessage
}

const PhoneNumber: React.FC<InputPhoneProps> = ({ values: { countryPhoneCode, codArea, phone, selectedCountry }, handleFieldValidation, handleFieldChange, handleResetValidation, handleNumberFieldChange, error, errorMessage, maxLengthcodArea, maxLengthNumber }) => {
  const { countries } = useSubscriberContext()
  const { setFields } = useFormContext()
  const [countryFlag, setCountryFlag] = useState('ar')

  useEffect(() => {
    if (selectedCountry) {
      const selectedCountryParsed = normalizeString(selectedCountry)
      const selectedPhoneNumber = countries.find(country => normalizeString(country.nombre) === selectedCountryParsed)
      setCountryFlag(normalizeString(selectedPhoneNumber?.codDN))
      setFields(prevState => ({
        ...prevState,
        document: '',
        countryPhoneCode: selectedPhoneNumber.paisCodTel,
        codArea: ''
      }))

    }
  }, [selectedCountry, countries])

  const handleSetCountryFlag = nombre => setCountryFlag(nombre)

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    if (e) {
      const countryString = e.target.value.toLowerCase()
      handleSetCountryFlag(countryString)
      handleFieldChange(e)
      const selectedPhoneNumber: ICountries = countries.find(country => normalizeString(country.codDN) === countryString)
      setFields(prevState => ({
        ...prevState,
        countryPhoneCode: selectedPhoneNumber.paisCodTel,
        areaCodePhone: selectedPhoneNumber.codDN,
        codArea: '',
        phone: '',
      }))
      handleFieldValidation(e)
    }
  }

  return (
    <FormControl isInvalid={error}>
      <FormHelperText className='form-helper-text' textStyle='bodySm'>Teléfono</FormHelperText>
      <Box>
        <InputGroup borderColor='neutral.90'>
          <InputAddon 
            className='form-input'
            bg='white'
            borderRadius='8px'
            borderBottomRightRadius='8px'
            borderTopRightRadius='8px'
            borderInlineEndColor='neutral.90'
            w='30%'
            pl='4px'
            pr={0}
            >
            <AvatarGroup>
              <Avatar size='xs' mx='4px' zIndex='2' src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${countryPhoneCode}.svg`} />
            </AvatarGroup>
            <Select 
              value={countryPhoneCode} 
              name='countryPhoneCode' 
              onChange={handleChange} 
              onFocus={handleResetValidation} 
              onBlur={handleFieldValidation} 
              data-testid='countryPhoneCode-input' 
              className='phoneNumber' 
              bg='white'
              border='none'
              h='100%'
              w='80%'
              p='0'
              _focus={{boxShadow: 'none'}}
              >
              {countries.map(({ codDN, paisCodTel }) => (
                // eslint-disable-next-line react/no-unknown-property
                <option value={codDN} key={codDN}>
                  +{paisCodTel}
                </option>
              ))}
            </Select>
          </InputAddon>
          <Input
            value={codArea}
            name='codArea'
            w='46%'
            onChange={handleNumberFieldChange}
            onBlur={handleFieldValidation}
            onFocus={handleResetValidation}
            maxLength={maxLengthcodArea}
            className='form-input'
            data-testid='codArea-input'
            bg='white'
            type='text'
            placeholder='Código'
            mx={2}
          />
          <Input
            value={phone}
            name='phone'
            data-testid='phone-input'
            onChange={handleNumberFieldChange}
            onBlur={handleFieldValidation}
            onFocus={handleResetValidation}
            maxLength={maxLengthNumber}
            className='form-input'
            bg='white'
            type='text'
            placeholder='Número'
          />
        </InputGroup>
        {error ? <FormErrorMessage>{errorMessage}</FormErrorMessage> : <FormHelperText textStyle='labelSm'>{errorMessage}</FormHelperText>}
      </Box>
    </FormControl>
  )
}

export default PhoneNumber
